import DataTableHead from "@eisinc/MobiusOverrides/DataTable/DataTableHead";

export default DataTableHead;

export * from "@eisinc/MobiusOverrides/DataTable/DataTableHead";
